import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IErrorResponse } from 'common/models/api-service/error-response.model';
import { ApiStatus } from 'common/enums';

import initialDownloadTemplateState from './downloadTemplate.state';

const downloadTemplateSlice = createSlice({
    name: 'dataEditor',
    initialState: initialDownloadTemplateState,
    reducers: {
        downloadFile: (state) => {
            if (!state.downloadFileStatus) {
                state.downloadFileStatus = {};
            }
            state.downloadFileStatus.status = ApiStatus.LOADING;
        },

        downloadFileSuccess: (state, { payload }: PayloadAction<Blob>) => {
            if (!state.downloadFileStatus) {
                state.downloadFileStatus = {};
            }
            state.downloadFileStatus.status = ApiStatus.SUCCESS;
            state.downloadFile = payload;
        },

        downloadFileFailed: (state, { payload }: PayloadAction<IErrorResponse>) => {
            if (!state.downloadFileStatus) {
                state.downloadFileStatus = {};
            }
            state.downloadFileStatus.status = ApiStatus.ERROR;
            state.downloadFileStatus.error = payload;
        }
    }
});

export default downloadTemplateSlice.reducer;
export const downloadTemplateActions = downloadTemplateSlice.actions;
